import { AxiosResponse } from 'axios';
import {
  DealerShowroom,
  DealerShowroomPhone,
  SearchShowroomPayload,
} from '../api/types/dealerApiTypes';
import { donedealGateway } from '../api/api-utils/commonApiUtils';
import type {
  IGetAdsRequest,
  ISearchPageFilter,
} from '../api/types/searchPageApiTypes';
import { IncomingHttpHeaders } from 'http';
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { API_LISTINGS_TIMEOUT },
} = getConfig();

async function getDealerShowroomById(
  payload: SearchShowroomPayload,
): Promise<AxiosResponse<DealerShowroom>> {
  const response: AxiosResponse<DealerShowroom> = await donedealGateway.post(
    '/ddapi/v1/search/showroom',
    payload,
  );
  return response;
}

async function getDealerShowroomByName(
  dealerName: string,
  payload: IGetAdsRequest,
  headers: IncomingHttpHeaders = { accept: 'application/json' },
  timeout?: number,
): Promise<AxiosResponse<DealerShowroom>> {
  const response: AxiosResponse<DealerShowroom> = await donedealGateway.post(
    `/ddapi/v1/search/showroom/${dealerName}`,
    payload,
    {
      headers: {
        ...headers,
        accept: 'application/json',
      },
      timeout: timeout || parseInt(API_LISTINGS_TIMEOUT),
    },
  );
  return response;
}

async function getDealerShowroomFilters(
  dealerId: string,
  section: string,
): Promise<AxiosResponse<ISearchPageFilter[]>> {
  const response: AxiosResponse<ISearchPageFilter[]> =
    await donedealGateway.get(
      `/ddapi/v1/search/showroom/filters/${section}?dealerId=${dealerId}`,
    );
  return response;
}

async function getDealerShowroomPhone(
  dealerId: string,
): Promise<AxiosResponse<DealerShowroomPhone>> {
  const response: AxiosResponse<DealerShowroomPhone> =
    await donedealGateway.get(
      `/ddapi/legacy/search/api/v4/dealer/${dealerId}/phone/?enquirySource=dealerShowroom`,
    );
  return response;
}

async function getDealerShowroomSeo(dealerId: string) {
  const response = await donedealGateway.get(
    `/ddapi/v1/seo/showroom/${dealerId}`,
  );
  return response;
}

export const dealerApi = {
  getDealerShowroomById,
  getDealerShowroomByName,
  getDealerShowroomFilters,
  getDealerShowroomPhone,
  getDealerShowroomSeo,
};
